module.exports = __webpack_public_path__ + "media/images/athletes/1602-95ab080e22d0aacdad49edf80ec33a80.png";